export const formDataAnnouncementCreate = (defaultData?: AnnouncementDto): FormParams => {
  return {
    items: {
      upperFields: [
        {
          element: 'input',
          type: 'text',
          id: 'title',
          placeHolder: 'Título do comunicado',
          label: 'Título do comunicado',
          defaultValue: defaultData ? defaultData.title : null,
        },
        {
          element: 'input',
          type: 'file',
          id: 'image',
          label: 'Adicionar imagem',
        },
        {
          element: 'textarea',
          id: 'description',
          placeHolder: 'Descrição do comunicado',
          label: 'Descrição do comunicado',
          rows: 5,
          defaultValue: defaultData
            ? defaultData.description
            : null,
        },
      ],
      bottomFields: [
        {
          element: 'input',
          type: 'file',
          id: 'attachment',
          label: 'Anexar arquivo',
        },
      ],
    },
    style: 'gray',
  };
};
